'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Format$HORIZONTAL$Fo;

var _Format = require('./Format');

var _Format2 = _interopRequireDefault(_Format);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = (_Format$HORIZONTAL$Fo = {}, _defineProperty(_Format$HORIZONTAL$Fo, _Format2.default.HORIZONTAL, [[970, 90], [728, 90], [468, 60], [234, 60]]), _defineProperty(_Format$HORIZONTAL$Fo, _Format2.default.RECTANGLE, [[336, 280], [300, 250], [250, 250], [200, 200], [180, 150], [125, 125]]), _defineProperty(_Format$HORIZONTAL$Fo, _Format2.default.VERTICAL, [[300, 600], [160, 600], [120, 600], [120, 240]]), _defineProperty(_Format$HORIZONTAL$Fo, _Format2.default.MOBILE, [[320, 50]]), _defineProperty(_Format$HORIZONTAL$Fo, _Format2.default.MOBILE_BIG, [[320, 100], [320, 50]]), _defineProperty(_Format$HORIZONTAL$Fo, _Format2.default.MOBILE_HORIZONTAL, [[970, 90], [728, 90], [468, 60], [320, 100], [320, 50], [234, 60]]), _defineProperty(_Format$HORIZONTAL$Fo, _Format2.default.PORTRET, [[300, 1050]]), _defineProperty(_Format$HORIZONTAL$Fo, _Format2.default.BILBORD, [[970, 250]]), _defineProperty(_Format$HORIZONTAL$Fo, '300x600', [[300, 600], [160, 600]]), _defineProperty(_Format$HORIZONTAL$Fo, '336x280', [[336, 280], [300, 250]]), _defineProperty(_Format$HORIZONTAL$Fo, '728x90', [[728, 90], [468, 60]]), _defineProperty(_Format$HORIZONTAL$Fo, '970x90', [[970, 90], [728, 90], [468, 60]]), _Format$HORIZONTAL$Fo);


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-google-publisher-tag/dist/constants/Dimensions.js
 ** module id = 458
 ** module chunks = 0
 **/